module.exports = __webpack_public_path__ + "static/img/haus2.0b1f694c.webp";